document.addEventListener('DOMContentLoaded', function () {
    // フェードインセクションの処理
    const fadeInSections = document.querySelectorAll('.fade-in-section');

    const appearOnScroll = new IntersectionObserver(function (entries, observer) {
        entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
        });
    }, {
        threshold: 0.2,
        rootMargin: "0px 0px -100px 0px" // ビューポートの下から100pxの位置でトリガー
    });

    fadeInSections.forEach(section => {
        appearOnScroll.observe(section);
    });

    // FAQアコーディオンの処理
    document.querySelectorAll('.faq-question').forEach(question => {
        question.addEventListener('click', function () {
            const answer = this.nextElementSibling;
            const iconPlus = this.querySelector('.plus');
            const iconMinus = this.querySelector('.minus');

            answer.classList.toggle('open');
            if (answer.classList.contains('open')) {
                answer.style.maxHeight = answer.scrollHeight + "px";
                iconPlus.style.display = 'none';
                iconMinus.style.display = 'block';
            } else {
                answer.style.maxHeight = "0";
                iconPlus.style.display = 'block';
                iconMinus.style.display = 'none';
            }
        });
    });

    // Readmoreの処理
    var targets = document.querySelectorAll('.readmore');
    var mores = document.querySelectorAll('.more');

    targets.forEach(function (target) {
        var readmoreInner = target.querySelector('.readmore_inner');

        // 一時的に非表示要素を表示して高さを取得する
        var originalDisplay = readmoreInner.style.display;
        readmoreInner.style.display = 'block'; // 要素を一時的に表示
        var initialHeight = readmoreInner.scrollHeight; // 要素の完全な高さを取得
        readmoreInner.style.display = originalDisplay; // 元の表示状態に戻す

        var more = target.nextElementSibling;

        if (initialHeight > 100) { // 100px以上ならアコーディオン処理を適用
            target.classList.add('hide');

            more.addEventListener('click', function () {
                var readmore = this.previousElementSibling;
                var morespan = this.querySelector('span');

                if (this.classList.contains('close')) {
                    this.classList.remove('close');
                    readmore.style.maxHeight = '200px';
                    readmore.classList.add('hide');
                    readmore.classList.remove('expanded');
                    morespan.textContent = 'もっと見る';
                } else {
                    readmore.style.maxHeight = '3000px'; // max-heightを3000pxに指定
                    readmore.classList.remove('hide');
                    readmore.classList.add('expanded');
                    this.classList.add('close');
                    morespan.textContent = '閉じる';
                    setTimeout(() => {
                        this.style.display = 'none';
                    }, 10);
                }
            });
        } else {
            var morespan = more.querySelector('span');
            morespan.parentNode.removeChild(morespan);
        }
    });

    // モーダル処理
    var modal = document.getElementById("myModal");
   
    var btn1 = document.getElementById("myBtn1");
    var btn2 = document.getElementById("myBtn2");

    var span = document.getElementsByClassName("close")[0];


    var videoUrls = {
        "myBtn1": "https://www.youtube.com/embed/BJyquRbFTPg?si=ktbC2Egx9i2WKF5u",
        "myBtn2": "https://www.youtube.com/embed/QT87I_F48jo?si=dCFMcxSO9x2p-4la",
      
    };

    // ボタンがクリックされたとき
    btn1.onclick = function () {
        document.getElementById("youtube-video").src = videoUrls["myBtn1"];
        modal.style.display = "block";
        document.body.classList.add('modal-open');
    }

    // btn2.onclick = function () {
    //     document.getElementById("youtube-video").src = videoUrls["myBtn2"];
    //     modal.style.display = "block";
    //     document.body.classList.add('modal-open');
    // }
 

    // 閉じるボタンがクリックされたとき
    span.onclick = function () {
        modal.style.display = "none";

        document.getElementById("youtube-video").src = "";

        document.body.classList.remove('modal-open');
    }
 


    // モーダルの外側がクリックされたとき
    window.onclick = function (event) {
        if (event.target == modal) {
            modal.style.display = "none";
            document.getElementById("youtube-video").src = "";
            document.body.classList.remove('modal-open');
        }
       
    }
});
